export { isChildOf, isElementOrChidOf };

const isElementOrChidOf = (el: Element, value: unknown): boolean => {
	return el === value || isChildOf(el, value);
};

const isChildOf = (el: Element, value: unknown): boolean => {
	if (value === undefined || value === null) {
		return false;
	}

	for (const child of el.children) {
		if (child === value || isChildOf(child, value)) {
			return true;
		}
	}

	return false;
};
